import { WSContainer } from "@wingspanhq/fe-component-library";
import { WingspanProductAspects } from "@wingspanhq/users/dist/lib/interfaces";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { useUserId } from "../../query/hooks/helpers";
import {
  useUpdateActivity,
  useUpdateMemberProfile
} from "../../query/users/mutations";
import { useMemberProfile } from "../../query/users/queries";
import { OnboardingHeader } from "../components/OnboardingHeader/OnboardingHeader";
import { OnboardingQuestion } from "../components/OnboardingQuestion/OnboardingQuestion";

interface OnboardingStep3BookkeepingProps {}

export const OnboardingStep3Bookkeeping: React.FC<OnboardingStep3BookkeepingProps> = () => {
  const history = useHistory();
  const userId = useUserId();
  const [updateActivity, updateActivityMeta] = useUpdateActivity(userId);
  const qMember = useMemberProfile(userId);
  const [
    updateMemberProfile,
    updateMemberProfileMeta
  ] = useUpdateMemberProfile();
  const onBack = () => {
    history.push("/member/onboarding/step/2");
  };
  const onSubmit = async (data: any) => {
    await updateMemberProfile({
      memberId: qMember.data?.memberId as string,
      profile: {
        productAspectImportance: [data.productAspectImportance]
      }
    });
    await updateActivity({
      flows: {
        onboarding: {
          version: 3,
          currentStep: 4,
          totalSteps: 4,
          complete: false
        }
      }
    });
    history.push("/member/onboarding/step/4/bookkeeping");
  };
  return (
    <>
      <BrowserPageTitle title="Onboarding: Step 3 | Bookkeeping" />
      <OnboardingHeader onBack={onBack} />
      <WSContainer verticalPadding>
        <OnboardingQuestion
          name="productAspectImportance"
          question={{
            question: "What could be better?",
            options: [
              {
                label: "Track income streams",
                value: WingspanProductAspects.TrackIncomeStreams,
                virtualAssistantMsg:
                  "Wingspan helps you see how much you're making across various accounts and income streams (i.e. PayPay, Venmo, Zelle, etc.)",
                ctaBtnText: "Try Bookkeeping"
              },
              {
                label: "Tracking expenses",
                value: WingspanProductAspects.ExpenseTracking,
                virtualAssistantMsg:
                  "Wingspan automatically flags deductible expenses, so you don't have to go through a shoebox of receipts at tax time.",
                ctaBtnText: "Try Bookkeeping"
              },
              {
                label: "Finding tax deductions",
                value: WingspanProductAspects.TaxDeductions,
                virtualAssistantMsg:
                  "Wingspan automatically flags deductible expenses, so you don't have to go through a shoebox of receipts at tax time.",
                ctaBtnText: "Try Bookkeeping"
              },
              {
                label: "Doing taxes",
                value: WingspanProductAspects.TaxFiling,
                virtualAssistantMsg:
                  "Wingspan not only calculates what to set aside as you get paid, it automates quarterly filings and payments too.",
                ctaBtnText: "Try Bookkeeping"
              }
            ]
          }}
          onSubmit={onSubmit}
          isSubmitting={
            updateMemberProfileMeta.isLoading || updateActivityMeta.isLoading
          }
          defaultValues={{
            productAspectImportance:
              qMember.data?.profile.productAspectImportance?.[0]
          }}
        />
      </WSContainer>
    </>
  );
};
